
const { protocol } = document.location as any;
let DEV_API = `${protocol}//192.168.5.134:81`
// DEV_API = location.origin

const config = {
    // 默认api地址
    dev_api: DEV_API,
    // 全局的监控状态
    global_anaylsis_status: false,
    // 监控系统一键更新是否开启状态
    oneClickUpdate: false,
    // 图片后缀，具体用来干么的我也忘了
    thumbsSuffix: '?second=0&width=400&height=180',
    // 域名集合
    domain_set: [
    {
        domain: 'plus.yoyi.com.cn',
        // 是否需要监控, 只有线上环境需要打开
        // 测试环境请勿开监控
        analysis: true,
        // api 地址
        apiUrl: {
            // 是否使用domain 作为host
            useDomain: true,
            // 如果false，必须填写默认地址
            defaultUrl: '**'
        }
    },{
        domain: 'dna.yoyi.com.cn',
        // 是否需要监控, 只有线上环境需要打开
        // 测试环境请勿开监控
        analysis: true,
        // api 地址
        apiUrl: {
            // 是否使用domain 作为host
            useDomain: true,
            // 如果false，必须填写默认地址
            defaultUrl: '**'
        }
    },
    {
        domain: 'plus4.yoyi.com.cn',
        // 是否需要监控, 只有线上环境需要打开
        // 测试环境请勿开监控
        analysis: true,
        // api 地址
        apiUrl: {
            // 是否使用domain 作为host
            useDomain: true,
            // 如果false，必须填写默认地址
            defaultUrl: '**'
        }
    },
    {
        domain: 'dsp.juyisharing.com',
        // 是否需要监控, 只有线上环境需要打开
        // 测试环境请勿开监控
        analysis: true,
        // api 地址
        apiUrl: {
            // 是否使用domain 作为host
            useDomain: true,
            // 如果false，必须填写默认地址
            defaultUrl: '**'
        }
    },
    {
        domain: 'dsp.avc-ott.com',
        analysis: false,
        apiUrl: {
            useDomain: true,
            defaultUrl: '**'
        }
    },
    {
        domain: 'hezhipp.com',
        analysis: false,
        apiUrl: {
            useDomain: true,
            defaultUrl: '**'
        }
    },
    {
        domain: 'adps.juhaokan.org',
        // 是否需要监控, 只有线上环境需要打开
        // 测试环境请勿开监控
        analysis: true,
        // api 地址
        apiUrl: {
            // 是否使用domain 作为host
            useDomain: true,
            // 如果false，必须填写默认地址
            defaultUrl: '**'
        }
    },
    {
        domain: 'dsp.opentide.cn',
        // 是否需要监控, 只有线上环境需要打开
        // 测试环境请勿开监控
        analysis: true,
        // api 地址
        apiUrl: {
            // 是否使用domain 作为host
            useDomain: true,
            // 如果false，必须填写默认地址
            defaultUrl: '**'
        }
    },
    {
        domain: '10.0.3.62',
        analysis: false,
        apiUrl: {
            useDomain: true,
        }
    },
    {
        domain: '10.0.13.162',
        analysis: false,
        apiUrl: {
            useDomain: true,
        }
    },
    {
        domain: '192.168.5.94',
        analysis: false,
        apiUrl: {
            useDomain: false,
            defaultUrl: DEV_API
        }
    },
    {
        domain: '192.168.5.131',
        analysis: false,
        apiUrl: {
            useDomain: true
        }
    },
    {
        domain: '10.0.2.10',
        analysis: false,
        apiUrl: {
            useDomain: true
        }
    },
    {
        domain: '10.0.2.15',
        analysis: false,
        apiUrl: {
            useDomain: true
        }
    },
    {
        domain: '117.121.2.36',
        analysis: false,
        apiUrl: {
            useDomain: true
        }
    }]
}

// matching current domain
const [matchDomain] = config.domain_set.filter(i => location.hostname.indexOf(i.domain) > -1)

// default host
let host  = config.dev_api as any
// 默认设置全局监控
let analysisStatus = config.global_anaylsis_status

// check matching
if (matchDomain) {
    // get current host
    host = matchDomain.apiUrl.useDomain ? `${protocol}//${location.host}` : matchDomain.apiUrl.defaultUrl
    // set current analysis status
    analysisStatus = matchDomain.analysis
}

const defaultOrigin =  `${protocol}//192.168.5.134:81/databank`

// format pathRoot
const pathRoot = `${host}/openapi`
// alertCenterApi
const warningUrl = `${host}/alertCenterApi`
// adminApi
const adminApi = `${host}/adminapi`
// format pathStaticRoot
const pathStaticRoot = `${host}/thumbs`
// format pathVideoRoot
const pathVideoRoot = `${host}/upload`
// img thumbsSuffix
const thumbsSuffix = config.thumbsSuffix
const databankRoot = `${defaultOrigin}/v1`
const databankNewApi = `${host}/databankapi`
// dnaApi
const dnaApi = `${host}/dnaapi`
const dmpApi = `${host}/dmpapi`
const ydmpApi = `${host}/yoyi-dmpapi`
const openApi = `${host}/openapi`
const labelApi = `${host}/labelapi`

export {
    pathRoot,
    thumbsSuffix,
    pathStaticRoot,
    analysisStatus,
    pathVideoRoot,
    warningUrl,
    databankRoot,
    databankNewApi,
    adminApi,
    dnaApi,
    dmpApi,
    ydmpApi,
    openApi,
    labelApi,
}